import React, { useState } from 'react';

export default function FormularioProducto({ agregarProducto }) {
    const [form, setForm] = useState({ producto: '', materiales: '', horas: '', departamento: 'C' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.producto || !form.materiales || !form.horas) return;
        
        await agregarProducto({
            producto: form.producto,
            materiales: parseFloat(form.materiales),
            horas: parseFloat(form.horas),
            departamento: form.departamento,
            createdAt: new Date().toISOString()
        });
        setForm({ producto: '', materiales: '', horas: '', departamento: 'C' });
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-6">
            <h3 className="text-sm font-bold text-gray-700 mb-4">Añadir Nuevo Producto</h3>
            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <input required placeholder="Nombre Producto" className="p-2 border border-gray-300 rounded text-sm" value={form.producto} onChange={e => setForm({...form, producto: e.target.value})} />
                <input required type="number" step="0.01" placeholder="Coste Mat. (€)" className="p-2 border border-gray-300 rounded text-sm" value={form.materiales} onChange={e => setForm({...form, materiales: e.target.value})} />
                <input required type="number" step="0.5" placeholder="Horas" className="p-2 border border-gray-300 rounded text-sm" value={form.horas} onChange={e => setForm({...form, horas: e.target.value})} />
                <select className="p-2 border border-gray-300 rounded text-sm" value={form.departamento} onChange={e => setForm({...form, departamento: e.target.value})}>
                    <option value="C">Carpintería (C)</option>
                    <option value="T">Tapicería (T)</option>
                </select>
                <div className="md:col-span-4 flex justify-end">
                    <button type="submit" className="bg-green-700 text-white px-6 py-2 rounded text-sm font-bold hover:bg-green-800">
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    );
}